export const loadingLock = (onchange) => {
  let isLoading = false;
  const acquire = () => {
    if (isLoading) {
      return false;
    }
    isLoading = true;
    onchange(isLoading);
    return true;
  };
  const release = () => {
    isLoading = false;
    onchange(isLoading);
  };
  return {
    acquire,
    release
  };
};
